import { DEVICE_ID_STORAGE_KEY } from './error-reporting.constants';

/**
 * UUID v4 generato una sola volta per dispositivo/browser e conservato in `localStorage`
 * (SPEC "Client": `civeshub.device_id`). Non è un dato sensibile: identifica un dispositivo, non
 * una persona, e serve al BE solo per raggruppare le occorrenze anonime (soggetto `D:<deviceId>`).
 *
 * `localStorage` (non `sessionStorage`): a differenza dei token, questo valore DEVE sopravvivere
 * alla chiusura dell'app per restare stabile nel tempo.
 */
export function getOrCreateDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existing) {
      return existing;
    }
    const generated = generateUuidV4();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, generated);
    return generated;
  } catch {
    // localStorage non disponibile (quota, contesto privato, ecc.): id volatile, non persistito.
    return generateUuidV4();
  }
}

function generateUuidV4(): string {
  const w = window as unknown as { crypto?: Crypto };
  if (w.crypto && typeof w.crypto.randomUUID === 'function') {
    return w.crypto.randomUUID();
  }
  // Fallback RFC 4122 v4 senza `crypto.randomUUID` (WebView datate).
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
